module.exports = __webpack_public_path__ + "img/banner.57602d57.png";